import { Stack } from '@mui/material';
import { OptionsTable } from './OptionsTable';
import { TypedOptionsTable } from './TypedOptionsTable';

export function GroupOptions() {
  return (
    <Stack direction="row" spacing={1} sx={{ p: 1 }}>
      <title>IR3 | Group & Area Options</title>
      <TypedOptionsTable name="groupType" title="Types" />
      <OptionsTable name="aliasType" title="Alias Types" />
    </Stack>
  );
}
